import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa"
  },
  rtl: localStorage.getItem("RENTAL_APP_LANG") === "ar" ? true : false,
  theme: {
    themes: {
      dark: {
        primary: "#0075FF",
        secondary: "#ffffff",
        pop: "#69F0AE",
        bg: "#f2f2f2ef",
        pop_bg: "#ffffff",
        solid: "#c16d87",
        table_body: "#f4e2ce",
        text_white: "#ffffff"
      },
      light: {
        primary: "#0075FF",
        secondary: "#363740",
        pop: "#69F0AE",
        bg: "#ffffff",
        pop_bg: "#ffffff",
        solid: "#c16d87",
        table_body: "#f4e2ce",
        text_white: "#ffffff"
      }
    }
  }
});
